<template>
  <el-dialog
    :visible.sync="isFormDialogVisible"
    custom-class="fifl-dialog right-fixed-dialog"
    :append-to-body="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    top="20px"
  >
    <div
      slot="title"
      class="dialog-header"
    >
      <h2>
        {{ form.id ? '회원권 수정' : '회원권 추가' }}
      </h2>
    </div>

    <ChildMembershipForm
      ref="childMembershipForm"
      :key="form.id || 0"
      v-model="form"
      :original-data="originalData"
    />

    <dialog-action-buttons
      ref="dialogActionButtons"
      slot="footer"
      @cancel="closeDialog"
      @confirm="handleClickSaveForm"
    />
    <!-- 
	Deprecated
	<alert-dialog
      title="회원권 등록 불가"
      message="설정하신 신규 회원권 기간이 기존 회원권 기간과 일부 중복되어 등록이 불가합니다. 기간이 겹치지 않도록 조정해주시길 바랍니다."
      :dialog-visible="validates.membershipOverlap.dialogVisible"
      @confirm="onCancelValidateDialog('membershipOverlap')"
    /> -->

    <booking-exist-warning-dialog
      title="회원권 바로 수정이 불가합니다."
      :message="validates.bookingExist.message"
      :dialog-visible="validates.bookingExist.dialogVisible"
      :bookings="bookings"
      :is-marking-previous-booking="true"
      cancel-button-text="모든 예약 취소하고 회원권 수정"
      confirm-button-text="확인"
      @confirm="onCancelValidateDialog('bookingExist')"
      @cancel="onConfirmValidateDialog('bookingExist')"
    />
    <announce-has-booking-dialog
      title="회원권 바로 수정이 불가합니다."
      :message="hasBookingCheckDialog.message"
      :dialog-visible="hasBookingCheckDialog.isVisible"
      cancel-button-text="모든 예약 취소하고 회원권 수정"
      confirm-button-text="내역 조회"
      @close="handleHasBookingCheckDialogClose"
      @confirm="handleBulkBookingManage"
      @cancel="handleConfirmDirectFix"
    />
  </el-dialog>
</template>

<script>
import dateFns from 'date-fns';
import DialogActionButtons from '@/components/dialogActionButtons';
import BookingExistWarningDialog from '@/components/BookingExistWarningDialog';
import AnnounceHasBookingDialog from '@/components/AnnounceHasBookingDialog';
import dialogValidateFormMixin from '@/mixins/dialogValidateFormMixin.js';
import { getBookingsOutOfRange } from '@/utils/date-helper';
import { computedGetters } from '@/utils/vuex-helper';
import ChildMembershipForm from '../ChildMembershipForm';
import {
  formResponseErrorHandler,
  MEMBERSHIP_CREATE_FAIL_MESSAGES,
  MEMBERSHIP_MODIFY_FAIL_MESSAGES
} from '@/fail-message-handler';

import { fiflboxApi } from '@/utils/api';

const BOOKING_DIALOG_MESSAGE_TEMPLATE = `수정하고자 한 기간인 <strong>{startDate} - {endDate}</strong>에
포함되지 않은 예약 내역이 존재합니다. 아래의 모든 예약 내역을
취소하시고 회원권 수정을 완료해주시길 바랍니다.`;

export default {
  name: 'MembershipFormDialog',
  components: {
    ChildMembershipForm,
    BookingExistWarningDialog,
    DialogActionButtons,
    AnnounceHasBookingDialog
  },
  mixins: [dialogValidateFormMixin],
  computed: {
    ...computedGetters(['loadingDialogVisible'])
  },
  props: ['enrollmentId', 'membershipDates'],
  data() {
    return {
      bookings: [],
      selectedParentMembership: null,
      parentMembershipCategories: [],
      parentCourseCategories: [],
      isFormDialogVisible: false,
      isConfirmButtonLoading: false,
      hasBooking: false,
      isDataFetch: false,
      membershipPrice: null, // 정상 금액
      paidAmount: null, // 결제 금액
      originalData: null,
      form: {
        parent_membership: null,
        parent_courses: [],
        start: null,
        end: null,
        duration: null,
        enrollment: null,
        consumed: 0,
        balance: null,
        payment: {
          classification: 2,
          cash: 0,
          card: 0,
          remainder: 0,
          paid_at: new Date().toDateFormat()
        },
        wait_consumed: 0
      },
      hasBookingCheckDialog: {
        isVisible: false,
        message: ''
      },
      validates: {
        bookingExist: {
          message: '',
          validateFunction: 'validateBookingExist',
          isValidated: false,
          dialogVisible: false
        }
        /*  Deprecated  */
        // membershipOverlap: {
        // 	validateFunction: "validateMembershipDateRange",
        // 	isValidated: false,
        // 	dialogVisible: false,
        // },
      }
    };
  },
  methods: {
    differenceInDays: dateFns.differenceInDays,
    async syncBookings() {
      if (!this.form.id) {
        return (this.bookings = []);
      }

      let { data: bookings } = await fiflboxApi.v1.getBookings({
        child_membership: this.form.id,
        status: ['BOOKED', 'PASS', 'WAITING']
      });

      this.bookings = getBookingsOutOfRange(
        bookings,
        this.form.start,
        this.form.end
      );
    },
    clearData(payload = {}) {
      return {
        parent_membership: null,
        parent_courses: [],
        start: null,
        end: null,
        duration: null,
        enrollment: null,
        consumed: 0,
        balance: null,
        payment: {
          classification: payload.classification || 2,
          cash: 0,
          card: 0,
          remainder: 0,
          paid_at: new Date().toDateFormat()
        },
        wait_consumed: 0
      };
    },

    openDialogToAdd(payload) {
      this.originalData = null;
      this.form = this.clearData(payload);
      this.isFormDialogVisible = true;
    },

    async openDialogToModify(childMembershipId) {
      const { data } = await fiflboxApi.v2.getChildMembershipsById(
        childMembershipId
      );

      // set for wait consumed into init data.
      data.consumed += data.wait_consumed;
      this.originalData = _.cloneDeep(data);
      this.form = data;
      this.isFormDialogVisible = true;
    },

    closeDialog() {
      this.originalData = null;
      this.isFormDialogVisible = false;
    },

    validateBookingExist() {
      if (!this.form.id) {
        return false;
      }

      if (this.bookings.length === 0) {
        return false;
      }

      this.validates.bookingExist.message = BOOKING_DIALOG_MESSAGE_TEMPLATE.replace(
        '{startDate}',
        dateFns.format(this.form.start, 'YYYY년 M월 D일')
      ).replace('{endDate}', dateFns.format(this.form.end, 'YYYY년 M월 D일'));

      return true;
    },

    async requestModifyMembership(form) {
      try {
        if (!this.loadingDialogVisible) {
          await this.fetchDataLoadingMessageVisible();
        }
        await fiflboxApi.v2.putChildMemberships(form.id, form);
        this.loadingMessageBoxHidden();
        return {
          isSuccess: true,
          error: null
        };
      } catch (err) {
        this.loadingMessageBoxHidden();
        return {
          isSuccess: false,
          error: err
        };
      }
    },

    async createMembership() {
      const { isSuccess, error } = await this.$store.dispatch(
        'createChildMembership',
        {
          childMembershipForm: this.form
        }
      );

      if (!isSuccess) {
        await formResponseErrorHandler(MEMBERSHIP_CREATE_FAIL_MESSAGES, error);
        return false;
      }

      return true;
    },
    async modifyMembership() {
      const { isSuccess, error } = await this.requestModifyMembership(
        this.form
      );

      if (!isSuccess) {
        await formResponseErrorHandler(MEMBERSHIP_MODIFY_FAIL_MESSAGES, error);
        return false;
      }

      return true;
    },
    async submitForm() {
      let isSuccess = this.form.id
        ? await this.modifyMembership()
        : await this.createMembership();

      if (!isSuccess) {
        this.stopButtonLoading();
        return false;
      }

      if (
        window.location.hash === '#/member/valid' ||
        window.location.hash === '#/member/expired'
      ) {
        this.stopButtonLoading();
        return false;
      }

      this.$message(
        this.form.id ? '회원권이 수정됐습니다.' : '회원권이 등록됐습니다.'
      );
      this.stopButtonLoading();
      this.closeDialog();
      this.$emit('update', this.form);
    },

    async handleClickSaveForm() {
      const childMembershipFormValid = this.$refs.childMembershipForm.validate();

      if (!childMembershipFormValid.isValid) {
        await this.$alert(
          '입력하지 않은 정보가 있어 회원권이 저장되지 않았습니다. 모든 정보를 입력해주세요.',
          '회원권 수정 불가'
        );
        this.stopButtonLoading();
        return;
      }
      const hasBooking = await this.hasBookingSearchByChildmembershipId();

      if (hasBooking) {
        this.hasBooking = true;
        const message = `
        수정하고자 한 기간인 <strong>{startDate} - {endDate}</strong>에
        포함되지 않은 예약 내역이 있습니다.<br>해당되는 모든 내역을 먼저
        취소하셔야 회원권 수정이 가능합니다.<br>바로 취소하시고 회원권을
        수정하시겠습니까?`
          .replace(
            '{startDate}',
            dateFns.format(this.form.start, 'YYYY년 M월 D일')
          )
          .replace(
            '{endDate}',
            dateFns.format(this.form.end, 'YYYY년 M월 D일')
          );
        this.hasBookingCheckDialogVisible(message);
      } else {
        if (this.form.id) {
          await this.fetchDataLoadingMessageVisible();
        }
        await this.handleBulkBookingManage();
      }
    },
    onCancelValidateDialog(validateName) {
      this.validates[validateName].dialogVisible = false;
      this.stopButtonLoading();
    },
    async hasBookingSearchByChildmembershipId() {
      if (!this.form.id) {
        return false;
      }

      const { data: result } = await fiflboxApi.v1.getBookingsOutOfRange({
        child_membership: this.form.id,
        start: this.form.start,
        end: this.form.end
      });

      return result.has_booking;
    },
    async handleBulkBookingManage() {
      if (this.hasBooking) {
        this.hasBookingCheckDialogHidden();
        this.loadingMessageBoxVisible(
          '해당되는 모든 예약 내역을 가져오고 있습니다.<br>잠시만 기다려 주세요.',
          'GET'
        );

        // 위에서 초기화 해줬기 때문에, 아래 조건을 위해 다시 켜주기.
        this.hasBooking = await true;
      }

      await this.syncBookings();
      this.form.enrollment = this.enrollmentId;

      if (this.hasBooking) {
        this.loadingMessageBoxHidden();
        // 다음 사이클을 위해 초기화.
        this.hasBooking = false;
      }

      this.validateForm();
    },
    hasBookingCheckDialogVisible(message) {
      this.hasBookingCheckDialog.message = message;
      this.hasBookingCheckDialog.isVisible = true;
    },
    hasBookingCheckDialogHidden() {
      this.hasBooking = false;
      this.hasBookingCheckDialog.isVisible = false;
    },
    loadingMessageBoxVisible(message, type) {
      if (type) {
        this.$store.commit('setLoadingDialogStatus', {
          target: 'type',
          value: type
        });
      }
      this.$store.commit('setLoadingDialogStatus', {
        target: 'message',
        value: message
      });
      this.$store.commit('setLoadingDialogStatus', {
        target: 'isVisible',
        value: true
      });
    },
    fetchDataLoadingMessageVisible() {
      this.hasBookingCheckDialogHidden();
      this.isDataFetch = true;
      this.loadingMessageBoxVisible(
        '회원권을 수정하고 있습니다.<br>다소 시간이 걸릴 수 있습니다. 잠시만 기다려 주세요.',
        'PUT'
      );
    },
    loadingMessageBoxHidden() {
      this.$store.commit('setLoadingDialogStatus', {
        target: 'type',
        value: ''
      });
      this.$store.commit('setLoadingDialogStatus', {
        target: 'isVisible',
        value: false
      });

      // 커스텀 alert가 열려있을 수 있기 때문에 함께 닫아준다.
      this.$store.commit('setCustomAlertStatus', {
        target: 'isVisible',
        value: false
      });
    },
    async handleConfirmDirectFix() {
      this.form.enrollment = this.enrollmentId;
      await this.onConfirmValidateDialog('bookingExist');
    },
    handleHasBookingCheckDialogClose() {
      this.hasBookingCheckDialogHidden();
      this.stopButtonLoading();
    },
    handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = '';
      return;
    },
    stopButtonLoading() {
      this.$refs['dialogActionButtons']
        ? this.$refs['dialogActionButtons'].stopLoading()
        : '';
    }
    /*  Deprecated  */
    // validateMembershipDateRange() {
    // 	let notOverlappedMemberships = this.membershipDates;

    // 	if (this.form.id) {
    // 		notOverlappedMemberships = this.membershipDates.filter(
    // 			membershipDate =>
    // 				!areDateRangesOverlapping(membershipDate, this.originalData)
    // 		);
    // 	}

    // 	if (notOverlappedMemberships.length === 0) {
    // 		return false;
    // 	}

    // 	let overlapDates = notOverlappedMemberships.filter(membershipDate =>
    // 		areDateRangesOverlapping(membershipDate, this.form)
    // 	);

    // 	return overlapDates.length > 0;
    // },
  }
};
</script>

<style lang="scss">
.right-fixed-dialog {
  position: absolute;
  top: 24px;
  right: 24px;
  bottom: 24px;
  margin: 0;
  display: flex;
  flex-direction: column;

  .el-dialog__header {
    flex: initial;
    order: 1;
  }

  .el-dialog__body {
    flex: 1;
    order: 2;
    overflow-y: auto;
  }

  .el-dialog__footer {
    flex: initial;
    order: 3;
  }
}
</style>
